import { Text, useFormInputs } from '@lbcamden/lib-react';
import { FunctionComponent, useEffect } from 'react';

import { actionsRecommendationsSchema } from '~/common/schemas/pcfra';

import { Container } from '../../PcfraCreateEditPage.styled';
import { SectionFormProps } from '../../types';
import { SectionHeading } from '../common.styled';
import { actionsRecommendationsFormConfig, ActionsRecommendationsFormValues } from './config';

export const ActionsRecommendations: FunctionComponent<SectionFormProps> = ({
  draftValues,
  showErrors,
  onChange,
}) => {
  const {
    formState: { data },
    formInputs,
  } = useFormInputs<ActionsRecommendationsFormValues>({
    schema: actionsRecommendationsSchema,
    config: actionsRecommendationsFormConfig,
    value: draftValues?.actionsRecommendations as ActionsRecommendationsFormValues,
    showErrors,
  });

  useEffect(() => {
    onChange({ actionsRecommendations: data });
  }, [data]);

  return (
    <>
      <Container>
        <SectionHeading>Actions & recommendations</SectionHeading>

        <div>
          <Text $weight={600}>Consider:</Text>
          <ul>
            <li>Risks to the resident and other occupiers of their home</li>
            <li>Risks of fire spread to common areas / other dwellings</li>
          </ul>
        </div>

        <div>
          <Text $weight={600}>Risk Reduction: Resident</Text>
          <ul>
            <li>Behavioural (consider level of support available)</li>
            <li>Fire retardant nightwear, bedding, floor coverings etc.</li>
            <li>AFA: Additional coverage, vibrating pads, telecare</li>
            <li>Thermal cut-outs, timers etc.</li>
            <li>
              Alternative cooking appliances e.g. removing gas Personal protection suppression
              systems
            </li>
            <li>Door upgrades, self-closers, hold-open devices</li>
          </ul>
        </div>

        <div>
          <Text $weight={600}>Risk Reduction: Premises</Text>
          <ul>
            <li>Particular consideration should be given to hoarding</li>
            <li>
              Replacement/upgraded flat entrance doors; measures to reduce tampering (e.g. motorised
              assistance)
            </li>
            <li>Fire stopping issues e.g. district heating, bathroom stacks</li>
            <li>Communal ductwork concerns</li>
            <li>Storage of mobility scooters</li>
          </ul>
        </div>

        <Text css={{ textDecoration: 'underline' }} $weight={600}>
          Other risk reduction measures may also be considered
        </Text>
      </Container>

      <Container>{formInputs}</Container>
    </>
  );
};
